import { slugify } from 'core/utils/strings';

const WK_SLUG_TO_ICON_NAME: Record<string, string> = {
  winter_wheat: 'wheat',
  hard_wheat: 'wheat',
  spring_barley: 'barley',
  winter_barley: 'barley',
  grape: 'grapes',
  apple: 'apples',
  tomato: 'tomatoes',
  cherry: 'cherries',
  onion: 'onions',
  turnip: 'turnips',
  maiz: 'corn',
  corn: 'corn',
  corn_maiz: 'corn'
};

export const wkSlugToCropIconName = (wkSlug?: string): string => {
  const normalised = slugify(wkSlug);
  if (!normalised) return '';
  return WK_SLUG_TO_ICON_NAME[normalised] ?? normalised;
};
